import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { loadDict, setLang as setModuleLang, t as tr, setDictEntry, LANGS } from "@/lib/i18n";

const browserLang = () => {
  const codes = LANGS.map(([c]) => c);
  for (const l of navigator.languages || [navigator.language || ""]) {
    const c = (l || "").slice(0, 2).toLowerCase();
    if (codes.includes(c)) return c;
  }
  return "en";
};
const initialLang = () => localStorage.getItem("fautras_lang") || browserLang();

const I18nContext = createContext({ lang: "fr", t: (s) => s, changeLang: () => {} });

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(initialLang);
  const [, setVersion] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const canTranslate = !!user && (user.role === "admin" || (!!user.can_translate && lang === user.translate_lang));
  const saveEntry = async (key, text) => {
    await api.put("/i18n", { lang, key, text });
    setDictEntry(lang, key, text);
    setVersion((v) => v + 1);
  };

  const apply = useCallback(async (l) => {
    await loadDict(l).catch(() => {});
    setModuleLang(l);
    setLangState(l);
    setVersion((v) => v + 1);
    localStorage.setItem("fautras_lang", l);
  }, []);

  useEffect(() => {
    if (user && user.lang) apply(user.lang);
    else apply(initialLang());
  }, [user, apply]);

  const changeLang = async (l) => {
    await apply(l);
    if (user) api.put("/me/lang", { lang: l }).catch(() => {});
  };

  return <I18nContext.Provider value={{ lang, changeLang, t: (s) => tr(s, lang), refresh: () => setVersion((v) => v + 1), editMode: editMode && canTranslate && lang !== "fr", setEditMode, canTranslate, saveEntry }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
